import styled from "styled-components";
import { COLORS, Z_INDEX } from "../styled";

export const ResumeSessionModalWindow = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 90%;
  background-color: ${COLORS.BLACK_BACKGROUND_OPACITY_0};
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: ${Z_INDEX.HIGHEST + 1};
`;

export const ResumeSessionColumn = styled.div`
  display: flex;
  flex-direction: column;
  width: 300px;
  height: 400px;
  background-color: ${COLORS.BLACK};
  border-radius: 20px;
  border-width: 1px;
`;

export const ResumeSessionTeams = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 55px;
  justify-content: center;
  padding-top: 11px;
`;

export const ResumeSessionSeat = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 50px;
  justify-content: center;
  padding-top: 17px;
`;

interface ResumeSessionSeatColumnProps {
  width?: string;
}

export const ResumeSessionSeatColumn = styled.div<ResumeSessionSeatColumnProps>`
  flex-direction: column;
  width: ${({ width }) => width || "33%"};
`;

export const ResumeSessionButtons = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: center;
  align-items: center;
  padding-top: 15px;
  padding-bottom: 10px;
`;
